import exp from "constants";
import { useEffect, useState } from "react";

export const WorkPageId = "page-work";
export const AboutPageId = "page-about";
export const MediaPageId = "page-media";
export const ServicesPageId = "page-services";
export const SkillsPageId = "page-skills";
export const ContactPageId = "page-contact";
export const LandingPageId = "page-landing";
export const ProfSummaryId = "page-prof-summary";
export const ServicesAnalyticsPageId = "page-service-analytics";
export const ServicesWorkshopPageId = "page-service-workshops";
export const ServicesBuildingOrgsPageId = "page-service-buildingorgs";
export const ServicesTechAdvicePageId = "page-service-tech-advice";
export const ResumePageId = "resume-page-id";



export enum Page {
    Work = "work",
    About = "about",
    Media = "media",
    Services = "services",
    Skills = "skills",
    Contact = "contact",
    Landing = "landing",
    ProfessionalSummary = "summary",
    ServiceAnalytics = "analytics",
    ServiceWorkshops = "workshops",
    ServiceBuidlingOrgs = "organizations",
    ServiceTechAdvice = "techadvice",
    ResumePageId = "resume"

}

const pageIds = [WorkPageId, AboutPageId , MediaPageId , ServicesPageId , SkillsPageId , ContactPageId , LandingPageId , ProfSummaryId, ServicesAnalyticsPageId , ServicesWorkshopPageId , ServicesBuildingOrgsPageId , ServicesTechAdvicePageId , ResumePageId];

export const useScroll = () => {
    const [page, setPage] = useState<string>("");

    const scrollHandler = () => {
        const documentTop = document.scrollingElement?.scrollTop!;
        const pages = pageIds.map((page) => document.getElementById(page));
        let newPage = "";

        pages.forEach((page) => {
            if (page) {
                const top = page.offsetTop;
                const height = page.clientHeight;

                if (top < documentTop && top + height > documentTop) {
                    newPage = page.id;
                }
            }
        });

        setPage(newPage);
    };

    useEffect(() => {
        setTimeout(() => {
            scrollHandler();
        }, 100);

        document.addEventListener("scroll", scrollHandler);

        return () => {
            document.removeEventListener("scroll", () => {});
        };
    }, []);

    return page;
};
